import PropTypes from 'prop-types'
import React from 'react'
import classes from './Routes.scss'
import Button from 'components/Button'
import List from 'components/List'

export const Routes = (props) => {
  const data = props.routes.map((route, index) => ({
    link: `/routes/${route.id}/edit`,
    data: [
      route.name,
      route.region
    ]
  }))
  const headers = [
    'name',
    'region'
  ]

  return (
    <div className={classes['collection']}>
      <header className={classes['header']}>
        <div className={classes['header-title']}>
          Browsing Routes
          <span className={classes['header-title--unimportant']}> – {props.routes.length}</span>
        </div>

        <div className={classes['header-buttons']}>
          <Button options={['green', 'small']} element='a' href='/routes/new'>
            Add Route
          </Button>
        </div>
      </header>

      <List data={data} headers={headers} />
    </div>
  )
}

Routes.propTypes = {
  routes: PropTypes.array.isRequired
}

Routes.defaultProps = {
  routes: []
}

export default Routes



// WEBPACK FOOTER //
// ./src/components/Routes/Routes.js